import axios from '@/shared/utils/axios-init';
import filterPagesByUrl from '@/shared/utils/helpers/filterPagesByUrl';

const initialState = {
  documentation: null,
  document: '',
  currentPage: null,
  errorAlert: null,
  helpMenu: [],
  footerInfo: [],
  footerDocs: [],
  footerSupport: [],
};

const getters = {
  getDocumentation: state => state.documentation,
  getDocument: state => state.document,
  getCurrentPage: state => state.currentPage,
  getErrorAlert: state => state.errorAlert,
  getHelpMenu: state => state.helpMenu,
  getFooterInfo: state => state.footerInfo,
  getFooterDocs: state => state.footerDocs,
  getFooterSupport: state => state.footerSupport,
};

const mutations = {
  setDocumentation(state, documentation) {
    state.documentation = documentation;
    state.helpMenu = [];
    state.footerInfo = [];
    state.footerDocs = [];
    state.footerSupport = [];

    documentation.forEach((item) => {
      if (+item.in_header) {
        state.helpMenu.push(item);
      }
      if (item.in_footer === 'info') {
        state.footerInfo.push(item);
        return;
      }
      if (item.in_footer === 'docs') {
        state.footerDocs.push(item);
      }
      if (item.in_footer === 'support') {
        state.footerSupport.push(item);
      }
    });
  },
  setDocument(state, document) {
    state.document = document;
  },
  setCurrentPage(state, page) {
    state.currentPage = page;
  },
  toggleErrorAlert(state, alert) {
    state.errorAlert = alert;
  },
};

const actions = {
  async fetchDocumentationData({ commit }) {
    try {
      const lang = localStorage.getItem('language');
      const { data } = await axios.post('/pages', { lang });
      const docsPages = filterPagesByUrl(data.pages);

      commit('setDocumentation', docsPages);
      return data;
    } catch (err) {
      /* eslint-disable */
      return err.response;
    }
  },

  async fetchDocumentData({ commit }, page) {
    commit('toggleErrorAlert', false);

    try {
      const lang = localStorage.getItem('language');
      const { data } = await axios.post(`/page`, { lang, keyword: page });

      // TODO: server return OK if page doesn't exist
      // therefore need to handle this error here
      //-----------------------------------------------
      if (!data.page) {
        commit('toggleErrorAlert', true);
        commit('setDocument', '');
        return;
      }
      
      commit('setDocument', data.page['content']);
      commit('setCurrentPage', page);

      return data;
    } catch (err) {
      commit('toggleErrorAlert', true);
      commit('setDocument', '');
      return err.response;
    }
  },
};


export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/modules/Docs/modules/documentation.js